module.exports = __webpack_public_path__ + "img/default.d5a816ad.png";